import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '@services/session/session.service';
import { CompanyPickerModel } from '@pageControls/company-picker/model/company-picker.model';

import { CompanyPickerModalComponent } from '../pageControls/company-picker/component/company-picker-modal.component';

@Component({
    selector: 'app-account-select',
    templateUrl: './account-select.component.html',
    styleUrls: ['./account-select.component.scss'],
    standalone: true,
    imports: [CompanyPickerModalComponent]
})
export class AccountSelectComponent implements OnInit {
  public NoAccounts = false;
  public ShowList = false;
  public LandingPage = '/portfolios';
  constructor( private session: SessionService,
               private model: CompanyPickerModel,
               private router: Router
              ) { }

  ngOnInit() {

  }

  BindAccountSelect(data) {
    if (this.session.GetSelectedCompanyID() === 0) {
      if (data.length === 0) {
        // show message about no access
        this.NoAccounts = true;
      }
    } else {
      // if user has previously selected and company
      const pCompany = data.filter(c => { return c.companyID === this.session.GetSelectedCompanyID(); });
      // if user still has access to the company, move on or open modal to let them pick again
      if (pCompany.length === 1) {
        this.router.navigate([this.LandingPage]);
      } else {
        this.ShowList = true;
      }
    }
  }
}

